import {
    prepareReportWorkbookDownload,
    getReportWorkbookDownloadStatus,
    getPreparedReportWorkbookChunk,
} from "../../../../service/httpsCalls";

export interface WorkbookDownloadJob {
    jobId: string;
    state: "queued" | "running" | "ready" | "failed";
    fileName?: string;
    fileBytes: number;
    error?: string;
    expiresUtc: string;
}

export const prepareWorkbook = async (reportId: number, versionId: number | null | undefined, signal: AbortSignal) =>
    (await prepareReportWorkbookDownload(reportId, versionId, signal)).data as WorkbookDownloadJob;
export const readWorkbookStatus = async (id: string, signal: AbortSignal) =>
    (await getReportWorkbookDownloadStatus(id, signal)).data as WorkbookDownloadJob;
export const readWorkbookChunk = getPreparedReportWorkbookChunk;

// Keep transport codes and internal exception text out of the download UI.
export const workbookDownloadErrorMessage = (error: unknown): string => {
    const failure = error as { response?: { status?: number; data?: { code?: string } }; code?: string; isAxiosError?: boolean };
    const status = failure?.response?.status;
    if (failure?.response?.data?.code === "REPORT_DATA_UNAVAILABLE")
        return "Report data is currently unavailable. Please contact support.";
    if (status === 410) return "This download is no longer available. Select Retry to prepare it again.";
    if (status === 401) return "Your session has ended. Sign in again, then retry this download.";
    if (status === 403) return "You no longer have access to this report. Contact your administrator if you need access.";
    if (status === 400) return "This saved report is unavailable. Refresh the report list before trying again.";
    if (status === 408 || status === 504 || failure?.code === "ECONNABORTED" || failure?.code === "ETIMEDOUT")
        return "The report service took too long to respond. Select Retry to try again.";
    if (status === 422 || status === 429) return "The report service is busy. Wait a moment, then select Retry.";
    if (status || failure?.isAxiosError) return "We couldn't download this report. Select Retry to try again.";
    return error instanceof Error ? error.message : "We couldn't download this report. Select Retry to try again.";
};
